import { breakpointSizes } from '../constants/breakpoints';
/**
 * Non react hook based util function to get current breakpoint directly.
 * Note: this is relies on window object which is available on client only.
 * @returns string ('xsmall' | 'small' | 'medium' | 'large' | 'xlarge' | 'xxl'). Default is xsmall on failure.
 */
const getCurrentBreakpoint = () => {
    const breakpointArray = Object.keys(breakpointSizes);
    const selectedBreakpoint = breakpointArray.find((breakpoint) => {
        const value = breakpointSizes[breakpoint];
        const { matches } = breakpoint === 'xxl'
            ? window.matchMedia(`(min-width: ${breakpointSizes.xlarge + 1}px)`)
            : window.matchMedia(`(max-width: ${value}px)`);
        return matches;
    }) || 'xsmall';
    return selectedBreakpoint;
};
export default getCurrentBreakpoint;
//# sourceMappingURL=getCurrentBreakpoint.js.map